// extracted by mini-css-extract-plugin
export default {"container":"TO-z","title":"UO-z","link":"VO-z"};